import React, { useState } from "react";
import "./NumberGrid.css";
import WinGoModal from "../../Common/Common_Component/Common_Modal/WinGoModal/WinGoModal";

function NumberGrid() {
  const [modalData, setModalData] = useState({ open: false, value: null, type: "" });

  const numSrc = [
    "/assets/images/bet_Select_section/coint_0.png",
    "/assets/images/bet_Select_section/coint_1.png",
    "/assets/images/bet_Select_section/coint_2.png",
    "/assets/images/bet_Select_section/coint_3.png",
    "/assets/images/bet_Select_section/coint_4.png",
    "/assets/images/bet_Select_section/coint_5.png",
    "/assets/images/bet_Select_section/coint_6.png",
    "/assets/images/bet_Select_section/coint_7.png",
    "/assets/images/bet_Select_section/coint_8.png",
    "/assets/images/bet_Select_section/coint_9.png",
  ];

  const handleCircleClick = (index) => {
    let type = "red"; // Default
    
    // Logic to match standard color-prediction game rules:
    if (index === 0 || index === 5) {
      type = "violet";
    } else if (index % 2 !== 0) {
      type = "green";
    } else {
      type = "red";
    }

    setModalData({
      open: true,
      value: index < 10 ? `0${index}` : index,
      type: type
    });
  };

  return (
    <>
      <div className="number_grid">
        {numSrc.map((src, index) => (
          <div
            key={index}
            className="number_circle"
            onClick={() => handleCircleClick(index)}
          >
            <img src={src} className="num_img" alt={`number-${index}`} />
          </div>
        ))}
      </div>

      {modalData.open && (
        <WinGoModal 
          selectedValue={modalData.value} 
          type={modalData.type} 
          onClose={() => setModalData({ ...modalData, open: false })}
        />
      )}
    </>
  );
}

export default NumberGrid;